<template>
<div class="chapter">
<div class="inner_page">
<h2 class="nobreak1" id="calibre_toc_9">CHAPTER THREE</h2>
<p class="noindent">Scripps left Mancelona. He was through with that
      place. What had a town like that to give him? There was
      nothing to it. You worked all your life and then a thing
      like that happened. The savings of years wiped out. Everything
      gone. He started to Chicago to get a job. Chicago
      was the place. Look at its geographical situation,
      right at the end of Lake Michigan. Chicago would do big
      things. Any fool could see that. He would buy land in
      what is now the Loop, the big shopping and manufacturing
      district. He would buy the land at a low price and
      then hang onto it. Let them try and get it away from
      him. He knew a thing or two now.</p>
<p class="calibre1">Alone, bareheaded, the snow blowing in his hair, he
      walked down the G. R. &amp; I. railway tracks. It was the
      coldest night he had ever known. He picked up a dead
      bird that had frozen and fallen onto the railroad tracks
      and put it inside his shirt to warm it. The bird nestled
      close to his warm body and pecked at his chest gratefully.</p>
<p class="calibre1">“Poor little chap,” Scripps said. “You feel the cold
      too.”</p>
<p class="calibre1">Tears came into his eyes.</p>
<p class="calibre1">“Drat that wind,” Scripps said and once again faced
      into the blowing snow. The wind was blowing straight
      down from Lake Superior. The telegraph wires above
      Scripps’s head sang in the wind. Through the dark,
      Scripps saw a great yellow eye coming toward him. The
      giant locomotive came nearer through the snow-storm.
      Scripps stepped to one side of the track to let it go by.
      What is it that old writing fellow Shakespeare says:
      “Might makes right”? Scripps thought of that quotation
      as the train went past him in the snowing darkness. First
      the engine passed. He saw the fireman bending to fling
      great shovelfuls of coal into the open furnace door. The
      engineer wore goggles. His face was lit up by the light
      from the open door of the engine. He was the engineer. It
      was he who had his hand on the throttle. Scripps thought
      of the Chicago anarchists who, when they were hanged,
      said: “Though you throttle us today, still you cannot
      something something our souls.” There was a monument
      where they were buried in Waldheim Cemetery, right beside
      the Forest Park Amusement Park, in Chicago. His
      father used to take Scripps out there on Sundays. The
      monument was all black and there was a black angel.
      That was when Scripps had been a little boy. He used
      often to ask his father: “Father, why if we come to look at
      the anarchists on Sunday why can’t we ride on the shoot
      the chutes?” He had never been satisfied with his father’s
      answer. He had been a little boy in knee pants then. His
      father had been a great composer. His mother was an
      Italian woman from the north of Italy. They are strange
      people, these north Italians.</p>
<p class="calibre1">Scripps stood beside the track, and the long black segments
      of the train clicked by him in the snow. All the
      cars were Pullmans. The blinds were down. Light came
      in thin slits from the bottom of the dark windows as the
      cars went by. The train did not roar by as it might have if
      it had been going in the other direction, because it was
      climbing the Boyne Falls grade. It went slower than if it
      had been going down. Still it went too fast for Scripps to
      hitch on. He thought how he had been an expert at
      hitching on grocery wagons when he was a young boy in
      knee pants.</p>
<p class="calibre1">The long black train of Pullman cars passed Scripps as
      he stood beside the tracks. Who were in those cars? Were
      they Americans, piling up money while they slept? Were
      they mothers? Were they fathers? Were there lovers
      among them? Or were they Europeans, members of a
      worn-out civilization world-weary from the war? Scripps
      wondered.</p>
<p class="calibre1">The last car passed him and the train went on up the
      track. Scripps watched the red light at its stern disappearing
      into the blackness through which the snowflakes
      now came softly. The bird fluttered inside his shirt.
      Scripps started along the ties. He wanted to get to Chicago
      that night, if possible, to start work in the morning.
      The bird fluttered again. It was not so feeble now.
      Scripps put his hand on it to still its little bird flutterings.
      The bird was calmed. Scripps strode on up the track.</p>
<p class="calibre1">After all, he did not need to go as far as Chicago.
      There were other places. What if that critic fellow Henry
      Mencken had called Chicago the Literary Capital of
      America? There was Grand Rapids. Once in Grand
      Rapids, he could start in in the furniture business. Fortunes
      had been made that way. Grand Rapids furniture
      was famous wherever young couples walked in the evening
      to talk of home-making. He remembered a sign he
      had seen in Chicago as a little boy. His mother had
      pointed it out to him as together they walked barefoot
      through what now is probably the Loop, begging from
      door to door. His mother loved the bright flashing of the
      electric lights in the sign.</p>
<p class="calibre1">“They are like San Miniato in my native Florence,”
      she told Scripps. “Look at them, my son,” she said, “for
      some day your music will be played there by the Firenze
      Symphony Orchestra.”</p>
<p class="calibre1">Scripps had often watched the sign for hours while his
      mother slept wrapped in an old shawl on what is now
      probably the Blackstone Hotel. The sign had made a
      great impression on him.</p>
<div class="lgc1">
<p class="line2">LET HARTMAN FEATHER YOUR</p>
<p class="line2">NEST</p>
</div>
<p class="noindent">it had said. It flashed in many different colors. First a
      pure, dazzling white. That was what Scripps loved best.
      Then it flashed a lovely green. Then it flashed red. One
      night as he lay crouched against his mother’s body
      warmth and watched the sign flash, a policeman came
      up. “You’ll have to move along,” he said.</p>
<p class="calibre1">Ah, yes, there was big money to be made in the furniture
      business if you knew how to go about it. He, Scripps,
      knew all the wrinkles of that game. In his own mind it
      was settled. He would stop at Grand Rapids. The little
      bird fluttered, happily now.</p>
<p class="calibre1">“Ah, what a beautiful gilded cage I’ll build for you, my
      pretty one,” Scripps said exultantly. The little bird
      pecked him confidently. Scripps strode on in the storm.
      The snow was beginning to drift across the track. Borne
      on the wind, there came to Scripps’s ears the sound of a
      far-off Indian war-whoop.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap3.vue?c37786c4